import {LoadingAnimation} from '../Components/LoadingAnimation';

export class PowermailSubmitUtility {
  readonly powermailForms;

  constructor() {
    this.powermailForms = document.querySelectorAll('.js-powermailForm');
    this.initializeSubmitListener();
  }

  private initializeSubmitListener(): void {
    [].forEach.call(this.powermailForms, (form): void => {
      form.addEventListener('submit', (): void => {
        const submitButton = form.querySelector('input[type=submit]');
        submitButton.classList.add('disabled');
        const animationWrapper = form.querySelector('.js-powermailLoadingWrapper');
        animationWrapper.classList.remove('hide');
        const loadingAnimation = new LoadingAnimation('.js-powermailLoadingAnimation');
        loadingAnimation.showLoadingAnimation();
      });
    });
  }
}
